// src/components/SocialIcons.jsx
import React from 'react';
import './SocialIcons.css';

export default function SocialIcons() {
  return (
    <div className="d-flex flex-wrap align-items-center gap-3 mb-3">
      <a href="https://www.facebook.com/share/16e9w4y6gr/" target="_blank" rel="noreferrer"
         className="social-icon facebook"><i className="fab fa-facebook-f" /></a>

      {/* <a href="https://www.x.com" target="_blank" rel="noreferrer"
         className="social-icon x"><i className="fab fa-x-twitter" /></a> */}


         <a href="https://chat.whatsapp.com/KtPOwKarhQJ4frqhmYZPOa?mode=ac_t" target="_blank" rel="noreferrer"
   className="social-icon whatsapp">
   <i className="fab fa-whatsapp" />
</a>


      <a href="https://www.youtube.com/@Technopal2023" target="_blank" rel="noreferrer"
         className="social-icon youtube"><i className="fab fa-youtube" /></a>

      <a href="https://t.me/+xOfXRC8bmKMxMDFi" target="_blank" rel="noreferrer"
         className="social-icon telegram"><i className="fab fa-telegram-plane" /></a>
    </div>
  );
}
